import {Component} from '@angular/core';
import {LoadingService} from './services/loadingService/loading.service';
import {TranslateService} from '@ngx-translate/core';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {

  constructor(public readonly loadingService: LoadingService,
              private readonly translateService: TranslateService) {
    this.loadingService.startLoading();
    this.translateService.setDefaultLang(navigator.language.slice(0,2));
    this.translateService.use(localStorage.getItem('lang') || navigator.language.slice(0,2));
  }
}
